// Shadow mode: build the vendor request, show it, record it, send nothing.
//
// Output lands in two places on purpose. The console line gives immediate
// feedback while clicking through a real signup; the PmsSyncJob row is the
// durable copy, in the same `request` column the live drainer will fill later,
// so nothing gathered during the shadow period is thrown away.

import { unresolvedFields } from './core';
import type { PmsLogger, PmsRequestEnvelope } from './core';

export const consoleLogger: PmsLogger = {
  info: (message, data) => console.info(message, data),
  warn: (message, data) => console.warn(message, data),
  error: (message, data) => console.error(message, data),
};

export interface ShadowRecord {
  vendorOp: string;
  path: string;
  body: unknown;
  /**
   * Vendor ids we do not know yet. moveIn and recordPayment need SSM's
   * TenantId/UnitId, which only exist once tenants are created for real and
   * units are backfilled — so a phase-1 body is exact except for these.
   */
  unresolved: string[];
  guard: 'pass';
  builtAt: string;
}

export function buildShadowRecord(envelope: PmsRequestEnvelope): ShadowRecord {
  return {
    vendorOp: envelope.vendorOp,
    path: envelope.path,
    body: envelope.body,
    unresolved: unresolvedFields(envelope),
    // The builders run the guard before returning, so reaching here means it passed.
    guard: 'pass',
    builtAt: new Date().toISOString(),
  };
}

export function logShadowRequest(envelope: PmsRequestEnvelope): void {
  const record = buildShadowRecord(envelope);
  console.info(`[pms:shadow] ${record.vendorOp} (not sent)`, record);
}
